import useLang from "../../../hooks/useLang";
import useUsers from "./useUsers";
import useModifierModal from "../../forms/hooks/useModifierModal";
import useConfirmationModal from "../../forms/hooks/useConfirmationModal";
import { usePostUserMutation, useRemoveUserMutation } from "../usersSlice";
import useUserBlock from "./useUserBlock";

const useUsersList = () => {
  const lang = useLang();
  const users = useUsers();
  const { formAttribs, formActions } = useModifierModal({
    mutationHook: usePostUserMutation,
    formConfigHook: useUserBlock,
  });

  const { formActions: removeFormActions } = useConfirmationModal({
    mutationHook: useRemoveUserMutation,
  });

  const data = users?.data?.map((user) => ({
    ...user,
    full_name: `${user?.given_name} ${user?.family_name}`,
  }));

  const config = useUserBlock();

  const removeUser = {
    id: "change",
    buttons: [
      {
        icon: "trashIcon",
        type: "confirmation-modal",
        mutation: "users.id.DELETE",
        deemphasize: true,
        hide: (data) => data?.roles?.indexOf("ADMIN") > -1,
        confirmationText: (data) =>
          `${lang("common.delete")} ${data?.full_name}?`,
        params: (data) => ({ userId: data?.id }),
        ...removeFormActions,
      },
    ],
  };

  const page = {
    hasAccess: users?.hasAccess,
    header: {
      title: users.isLoading
        ? lang("users.users_loading")
        : lang("users.title"),
      buttons: {
        caption: lang("common.create"),
        icon: "plus",
        title: lang("users.create"),
        type: "modifier-modal",
        mutation: "users.POST",
        formAttribs,
        ...formActions,
      },
    },
    items: {
      id: "usersTable",
      type: "table",
      data,
      config: [...config, removeUser],
    },
  };

  return page;
};

export default useUsersList;
